var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"videos"}},[_c('TopList',{attrs:{"navList":_vm.navList},on:{"setType":_vm.setType}}),_c('Video')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }